import http from "../services/http";

// Get all patients (with optional filters)
export const apiGetFollowUps = async (params = {}) => {
  try {
    const response = await http.get("/api/doctor/follow-up", { params });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get patient details by ID
export const apiGetFollowUpReview = async (session_id ) => {
  try {
    const response = await http.get(`/api/doctor/follow-up/review`, {
      params: { session_id  },
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};